import { ActivatedRoute, Params, Router } from '@angular/router';
import { LocalStorageManager } from '@cloud/main/shared/helpers/local-storage-manager.helper';
import { SearchParamsHelper } from 'cloud-shared-lib';
import * as _ from 'lodash';
import { Observable, debounceTime, tap } from 'rxjs';

export abstract class FilterParams {
  filters: Params;
  urlChanged$: Observable<Params>;

  get pageSize(): number {
    const pageSize = LocalStorageManager.pageSizes?.[this.router.url.split('?')[0]] ?? 25;
    return pageSize;
  }

  get filtersSalon(): Params {
    return LocalStorageManager.filtersSalon;
  }

  constructor(public route: ActivatedRoute, public router: Router) {
    this.urlChanged$ = this.route.queryParams.pipe(
      debounceTime(500),
      tap(res => {
        if (!_.isEmpty(res)) {
          _.mergeWith(this.filters, res, (a, b) => {
            if (_.isArray(b)) {
              return b.map(value => Number(value));
            }
            if (b === 'true' || b === 'false') {
              return b === 'true';
            }
            return b;
          });
        }
      })
    );
  }

  updateQueryParams(newQueryParams: Params): void {
    SearchParamsHelper.updateQueryParams(this.router, this.route, newQueryParams);
  }
}
